<ng-template #loadingWidgets>
    <mat-chip-list class="widget-list widgets-loading animated fadeIn">
        <mat-chip disabled></mat-chip>
        <mat-chip disabled></mat-chip>
        <ng-container *ngIf="!twoGridLayout">
            <mat-chip disabled></mat-chip>
            <mat-chip disabled></mat-chip>
        </ng-container>
    </mat-chip-list>
</ng-template>

<ng-container *ngIf="!isLoadingInitialData; else loadingWidgets">
    <mat-chip-list class="widget-list animated fadeIn" [class.empty]="widgets.length === 0">
        <mat-chip *ngFor="let widget of widgets.slice(widgetIndex, widgetIndex + (twoGridLayout ? 2 : 4))"
                  [disableRipple]="true"
                  [selected]="selectedWidget.isSelected(widget)"
                  (click)="toggleWidget(widget)">
            <span class="widget-total">{{ widget.total }}</span>
            <span class="widget-label">{{ widget.label | capitalize }}</span>
        </mat-chip>
    </mat-chip-list>
</ng-container>

<mat-toolbar>
    <toolbar-spacer></toolbar-spacer>

    <button *ngIf="widgets.length > (twoGridLayout ? 2 : 4)"
            mat-icon-button disableRipple
            [attr.aria-label]="'Show previous widgets'"
            [disabled]="isLoadingInitialData || widgetIndex === 0"
            (click)="prevSet()">
        <mat-icon>arrow_back</mat-icon>
    </button>

    <button-spacer *ngIf="!twoGridLayout" [size]="'sm'"></button-spacer>

    <button *ngIf="widgets.length > (twoGridLayout ? 2 : 4)"
            mat-icon-button disableRipple
            [attr.aria-label]="'Show next widgets'"
            [disabled]="isLoadingInitialData || lastPage"
            (click)="nextSet()">
        <mat-icon>arrow_forward</mat-icon>
    </button>

    <toolbar-spacer *ngIf="twoGridLayout"></toolbar-spacer>
</mat-toolbar>
